var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiataLogoGreyed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350.2 69.2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.809982, -19.974998)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.17,61.29h-19.48l-3.41,7.94c-0.84,1.96-1.26,3.41-1.26,4.38c0,0.77,0.36,1.44,1.09,2.02 c0.73,0.58,2.31,0.96,4.73,1.13v1.37h-15.85v-1.37c2.1-0.37,3.46-0.85,4.08-1.45c1.26-1.19,2.66-3.6,4.19-7.24l17.7-41.41h1.3 l17.52,41.86c1.41,3.37,2.69,5.55,3.84,6.55c1.15,1,2.75,1.57,4.81,1.69v1.37h-19.85v-1.37c2-0.1,3.36-0.43,4.06-1 c0.71-0.57,1.06-1.26,1.06-2.08c0-1.09-0.5-2.81-1.48-5.16L204.17,61.29z M203.13,58.54L194.6,38.2l-8.76,20.34H203.13z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.08,27.81l0.56,11.8h-1.41c-0.27-2.08-0.64-3.56-1.11-4.45c-0.77-1.43-1.79-2.49-3.06-3.17 c-1.27-0.68-2.95-1.02-5.03-1.02h-7.09v38.44c0,3.09,0.33,5.02,1,5.79c0.94,1.04,2.39,1.56,4.34,1.56h1.74v1.37h-21.34v-1.37h1.78 c2.13,0,3.64-0.64,4.53-1.93c0.54-0.79,0.82-2.6,0.82-5.42V30.97h-6.05c-2.35,0-4.02,0.17-5.01,0.52 c-1.29,0.47-2.39,1.37-3.3,2.71c-0.92,1.34-1.46,3.14-1.63,5.42h-1.41l0.59-11.8H293.08z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,26.66l1.3,15.88h-1.3c-1.31-3.96-3.01-6.94-5.08-8.94c-2.99-2.89-6.84-4.34-11.54-4.34 c-6.41,0-11.28,2.54-14.62,7.61c-2.8,4.28-4.19,9.38-4.19,15.29c0,4.8,0.93,9.18,2.78,13.14c1.86,3.96,4.29,6.86,7.29,8.7 c3.01,1.84,6.09,2.76,9.26,2.76c1.86,0,3.65-0.23,5.38-0.7c1.73-0.47,3.4-1.16,5.01-2.08V59.43c0-2.52-0.19-4.17-0.58-4.95 c-0.38-0.78-0.98-1.37-1.78-1.78c-0.8-0.41-2.22-0.61-4.25-0.61v-1.41h19.48v1.41h-0.93c-1.93,0-3.25,0.64-3.97,1.93 c-0.5,0.92-0.74,2.72-0.74,5.42v15.4c-2.85,1.53-5.65,2.66-8.42,3.38c-2.77,0.72-5.85,1.08-9.24,1.08 c-9.72,0-17.11-3.12-22.15-9.35c-3.79-4.68-5.68-10.07-5.68-16.18c0-4.43,1.06-8.67,3.19-12.73C31.54,36.2,35,32.49,39.4,29.89 c3.69-2.15,8.04-3.23,13.06-3.23c1.83,0,3.49,0.15,4.99,0.45c1.5,0.3,3.62,0.95,6.36,1.97c1.39,0.52,2.31,0.78,2.78,0.78 c0.47,0,0.87-0.22,1.21-0.65c0.33-0.43,0.54-1.28,0.61-2.54H69.8z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.25,19.99v69.17H93.4V19.99H95.25z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.21,76.76v1.37h-21.56v-1.37h1.78c2.08,0,3.59-0.61,4.53-1.82c0.59-0.79,0.89-2.7,0.89-5.71V36.72 c0-2.55-0.16-4.23-0.48-5.05c-0.25-0.62-0.75-1.15-1.52-1.6c-1.09-0.59-2.23-0.89-3.41-0.89h-1.78v-1.37h21.56v1.37h-1.82 c-2.05,0-3.55,0.61-4.49,1.82c-0.62,0.79-0.93,2.7-0.93,5.71v32.51c0,2.55,0.16,4.23,0.48,5.05c0.25,0.62,0.77,1.15,1.56,1.6 c1.06,0.59,2.19,0.89,3.38,0.89H135.21z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.23,19.99v69.17h-1.85V19.99H155.23z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.99,19.99v69.17h-1.85V19.99H237.99z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,19.99v69.17h-1.85V19.99H308.7z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.74,61.29h-19.48l-3.41,7.94c-0.84,1.96-1.26,3.41-1.26,4.38c0,0.77,0.36,1.44,1.09,2.02 c0.73,0.58,2.31,0.96,4.73,1.13v1.37h-15.85v-1.37c2.1-0.37,3.46-0.85,4.08-1.45c1.26-1.19,2.66-3.6,4.19-7.24l17.7-41.41h1.3 l17.51,41.86c1.41,3.37,2.69,5.55,3.84,6.55c1.15,1,2.75,1.57,4.81,1.69v1.37h-19.85v-1.37c2-0.1,3.36-0.43,4.06-1 c0.71-0.57,1.06-1.26,1.06-2.08c0-1.09-0.5-2.81-1.48-5.16L356.74,61.29z M355.7,58.54l-8.54-20.34l-8.76,20.34H355.7z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiataLogoGreyed);
export default __webpack_public_path__ + "static/media/Giata_logo_greyed.b85a03bcbc50668ef7474f63669f7291.svg";
export { ForwardRef as ReactComponent };